import React from 'react';
import { Spinner } from '..';
import { MediaSize } from '../../enums';
import { isMediaSizeLessThanMD } from '../../helpers';

type FixedLoaderProps = {
    size?: MediaSize;
};

// Extracted from helpers/general. This loader component should be merged with the other two to create a general purpose loader
export const FixedLoader = ({ size }: FixedLoaderProps): JSX.Element => {
    const isSmall = isMediaSizeLessThanMD(size);
    return (
        <div
            className="position-absolute"
            style={{
                top: isSmall ? 'calc(50% - 10px)' : 'calc(50% - 32px)',
                left: isSmall ? 'calc(50% - 10px)' : 'calc(50% - 32px)',
                zIndex: 1,
            }}
        >
            <Spinner />
        </div>
    );
};
